<template>
    <LoginPage :theme='G.theme' />
</template>

<script>
    import LoginPage from "@/pages/login/Login";

    // import LoginPage from "@/pages/login/Login_Black_FW";
    // import LoginPage from "@/pages/login/Login_W";
    // import LoginPage from "@/pages/login/Login_White_FW";
    // import LoginPage from "@/pages/login/LoginBlackCentered";
    // import LoginPage from "@/pages/login/LoginBlackFW";
    // import LoginPage from "@/pages/login/LoginBlackImage";
    // import LoginPage from "@/pages/login/LoginContainerImage";
    // import LoginPage from "@/pages/login/LoginWhiteImage";

    import {G} from "@/_common";

    export default {
        name: 'LoginL',
        components: {
            LoginPage,
        },
        props: {
            data: {
                type: Object,
            },
        },
        setup() {
            return { G };
        },
    };
</script>

<style lang="scss">

</style>
